/* ============================================================
   BLOME theme interactions — real Shopify cart + UI
   Delegated + defensive so it works on any page.
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const money = n => '$' + Number(n || 0).toFixed(2);
  const moneyC = c => '$' + (Number(c || 0) / 100).toFixed(2);

  /* ---------- Announcement rotator ---------- */
  const msgs = $$('.announce .msg');
  if (msgs.length > 1) {
    let ai = 0;
    setInterval(() => { msgs[ai].classList.remove('on'); ai = (ai + 1) % msgs.length; msgs[ai].classList.add('on'); }, 3800);
  }

  /* ---------- Header scrolled state ---------- */
  const header = $('.blome .bl-header');
  if (header) addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 20), { passive: true });

  /* ---------- Mobile menu ---------- */
  const mmenu = $('#blome-mmenu');
  const openM = () => { if (mmenu) { mmenu.classList.add('show'); document.body.style.overflow = 'hidden'; } };
  const closeM = () => { if (mmenu) { mmenu.classList.remove('show'); document.body.style.overflow = ''; } };
  $$('[data-blome-burger]').forEach(b => b.addEventListener('click', openM));
  $$('[data-blome-close-menu]').forEach(b => b.addEventListener('click', closeM));

  /* ---------- Search ---------- */
  const searchModal = $('#blome-search');
  const searchInput = $('#blome-search-input');
  const openS = () => { if (searchModal) { searchModal.classList.add('show'); document.body.style.overflow = 'hidden'; setTimeout(() => searchInput && searchInput.focus(), 300); } };
  const closeS = () => { if (searchModal) { searchModal.classList.remove('show'); document.body.style.overflow = ''; } };
  $$('[data-blome-search-open]').forEach(b => b.addEventListener('click', openS));
  $$('[data-blome-search-close]').forEach(b => b.addEventListener('click', closeS));
  function searchIndex() {
    return $$('.bl-card[data-cat]').map(c => ({
      name: (c.dataset.name || $('h3', c)?.textContent || '').trim(),
      shade: (c.dataset.shade || $('.card-shade', c)?.textContent || '').trim(),
      cat: c.dataset.cat || '', price: c.dataset.price || '',
      img: c.dataset.img || $('img', c)?.getAttribute('src') || '', href: c.dataset.href || '#'
    })).filter((v, i, a) => a.findIndex(x => x.name + x.shade === v.name + v.shade) === i);
  }
  function runSearch(q) {
    const res = $('#blome-search-res'), sug = $('#blome-search-sug');
    if (!res) return;
    q = q.trim().toLowerCase();
    if (!q) { res.innerHTML = ''; if (sug) sug.style.display = 'block'; return; }
    if (sug) sug.style.display = 'none';
    const m = searchIndex().filter(p => (p.name + ' ' + p.shade + ' ' + p.cat).toLowerCase().includes(q)).slice(0, 6);
    res.innerHTML = m.length ? m.map(p => `<a class="sres" href="${p.href}"><img src="${p.img}" alt="" loading="lazy"><div><b>${p.name}${p.shade ? ' · ' + p.shade : ''}</b><span>${p.cat}</span></div>${p.price ? `<span class="sp">${money(p.price)}</span>` : ''}</a>`).join('') : `<div style="padding:20px;color:var(--taupe);font-size:14px">No results for "${q}"</div>`;
  }
  if (searchInput) searchInput.addEventListener('input', e => runSearch(e.target.value));
  $$('#blome-search-sug button').forEach(b => b.addEventListener('click', () => { if (searchInput) { searchInput.value = b.textContent; runSearch(b.textContent); searchInput.focus(); } }));
  const searchForm = $('#blome-search-form');
  if (searchForm) searchForm.addEventListener('submit', e => e.preventDefault());

  /* ============================================================
     REAL Shopify cart (AJAX) rendered into the BLOME drawer
     ============================================================ */
  let CART = null;
  const drawer = $('#blome-drawer'), overlay = $('#blome-overlay');
  const FREE = parseFloat((drawer && drawer.dataset.freeship) || '35') || 35;
  const openCart = () => { if (drawer) { drawer.classList.add('show'); overlay && overlay.classList.add('show'); document.body.style.overflow = 'hidden'; } };
  const closeCart = () => { if (drawer) { drawer.classList.remove('show'); overlay && overlay.classList.remove('show'); document.body.style.overflow = ''; } };
  $$('[data-blome-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  $$('[data-blome-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  function renderCart(cart) {
    if (!cart) return;
    const count = cart.item_count || 0;
    const cc = $('#blome-cart-count'); if (cc) { cc.textContent = count; cc.classList.toggle('show', count > 0); }
    const ct = $('#blome-drawer-ct'); if (ct) ct.textContent = '(' + count + ')';
    const subD = (cart.total_price || 0) / 100;
    const fill = $('#blome-ship-fill'); if (fill) fill.style.width = Math.min(100, (subD / FREE) * 100) + '%';
    const st = $('#blome-ship-text'); if (st) { const r = Math.max(0, FREE - subD); st.innerHTML = r > 0 ? `You're <b>${money(r)}</b> away from free shipping` : `🎉 You've unlocked <b>free shipping</b>`; }
    const body = $('#blome-drawer-body'), foot = $('#blome-drawer-foot');
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = `<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><p>Your bag is empty</p><small>Let's find your forever shade.</small></div>`;
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(i => {
      const img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      const variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      return `<div class="citem">
        <a class="citem-img" href="${i.url}"><img src="${img}" alt="${i.product_title}"></a>
        <div class="citem-info"><h4><a href="${i.url}">${i.product_title}</a></h4><div class="cs">${variant}</div><div class="cp">${moneyC(i.final_price)}</div>
          <div class="qty"><button data-dec="${i.key}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-inc="${i.key}" aria-label="Increase">+</button></div></div>
        <button class="citem-rm" data-rm="${i.key}">Remove</button></div>`;
    }).join('');
    const subEl = $('#blome-subtotal'); if (subEl) subEl.textContent = moneyC(cart.total_price);
    if (foot) foot.style.display = 'block';
  }

  async function getCart() { try { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); return await r.json(); } catch (e) { return null; } }
  async function refresh() { CART = await getCart(); renderCart(CART); return CART; }
  async function addVariant(id, qty, btn) {
    if (!id) return;
    if (btn) { btn.dataset._label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) });
      if (!r.ok) { const err = await r.json().catch(() => ({})); toast(err.description || 'Sorry, that shade is unavailable'); return; }
      await refresh(); openCart(); toast('Added to your bag');
    } catch (e) { toast('Could not add to bag'); }
    finally { if (btn && btn.dataset._label) { btn.textContent = btn.dataset._label; btn.disabled = false; } }
  }
  async function changeLine(key, qty) {
    try { const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }); CART = await r.json(); renderCart(CART); } catch (e) {}
  }

  document.addEventListener('click', e => {
    const add = e.target.closest('[data-add-variant]');
    if (add) { e.preventDefault(); addVariant(add.dataset.addVariant, parseInt(add.dataset.addQty || '1', 10), add); return; }
    const inc = e.target.closest('[data-inc]'), dec = e.target.closest('[data-dec]'), rm = e.target.closest('[data-rm]');
    if (inc) { const it = CART && CART.items.find(i => i.key === inc.dataset.inc); if (it) changeLine(it.key, it.quantity + 1); }
    if (dec) { const it = CART && CART.items.find(i => i.key === dec.dataset.dec); if (it) changeLine(it.key, it.quantity - 1); }
    if (rm) { changeLine(rm.dataset.rm, 0); }
  });
  refresh();

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) { const t = $('#blome-toast'); if (!t) return; const m = $('#blome-toast-msg'); if (m) m.textContent = msg; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2600); }

  /* ---------- Wishlist ---------- */
  document.addEventListener('click', e => { const w = e.target.closest('.wish'); if (w) { e.preventDefault(); w.classList.toggle('on'); } });

  /* ---------- Shade selectors (feature + PDP) ---------- */
  document.addEventListener('click', e => {
    const fsw = e.target.closest('.feat-sw');
    if (fsw) {
      const wrap = fsw.closest('.swatch-row');
      $$('.feat-sw', wrap).forEach(x => x.classList.remove('active'));
      fsw.classList.add('active');
      const img = $('#blome-feat-img'), name = $('#blome-feat-name');
      if (img && fsw.dataset.img) { img.style.opacity = 0; setTimeout(() => { img.src = fsw.dataset.img; img.style.opacity = 1; }, 200); }
      if (name && fsw.dataset.name) name.textContent = fsw.dataset.name;
      const cta = $('#blome-feat-cta'); if (cta && fsw.dataset.url) cta.href = fsw.dataset.url;
    }
    const psw = e.target.closest('.pdp-sw');
    if (psw) {
      const wrap = psw.closest('.pdp-shades');
      $$('.pdp-sw', wrap).forEach(x => x.classList.remove('active'));
      psw.classList.add('active');
      const img = $('#blome-pdp-img'), name = $('#blome-pdp-shade'), add = $('#blome-pdp-add');
      if (img && psw.dataset.img) { img.style.opacity = 0; setTimeout(() => { img.src = psw.dataset.img; img.style.opacity = 1; }, 180); }
      if (name && psw.dataset.name) name.textContent = psw.dataset.name;
      if (add && psw.dataset.variant) add.dataset.addVariant = psw.dataset.variant;
      if (add && psw.dataset.url) add.dataset.url = psw.dataset.url;
    }
    const th = e.target.closest('.pdp-thumb');
    if (th) {
      const wrap = th.closest('.pdp-thumbs');
      $$('.pdp-thumb', wrap).forEach(x => x.classList.remove('active'));
      th.classList.add('active');
      const img = $('#blome-pdp-img');
      if (img && th.dataset.img) { img.style.opacity = 0; setTimeout(() => { img.src = th.dataset.img; img.style.opacity = 1; }, 160); }
    }
  });

  /* ---------- Product page variant picker ---------- */
  document.addEventListener('click', e => {
    const vb = e.target.closest('[data-variant-btn]');
    if (!vb) return;
    const scope = vb.closest('[data-product-variants]');
    if (!scope) return;
    $$('[data-variant-btn]', scope).forEach(x => x.classList.remove('active'));
    vb.classList.add('active');
    const addBtn = $('[data-add-variant]', scope);
    if (addBtn && vb.dataset.variantBtn) addBtn.dataset.addVariant = vb.dataset.variantBtn;
    const priceEl = $('[data-variant-price]', scope);
    if (priceEl && vb.dataset.variantPrice) priceEl.textContent = vb.dataset.variantPrice;
    const label = $('[data-variant-label]', scope);
    if (label && vb.dataset.variantName) label.textContent = vb.dataset.variantName;
    const mainImg = $('[data-product-main-img]', scope) || $('#blome-pdp-img');
    if (mainImg && vb.dataset.img) { mainImg.style.opacity = 0; setTimeout(() => { mainImg.src = vb.dataset.img; mainImg.style.opacity = 1; }, 160); }
  });

  /* ---------- Collection tabs (each tab = a collection group) ---------- */
  $$('[data-product-tabs]').forEach(tabs => {
    const section = tabs.closest('.bl-section') || tabs.closest('.blome') || document;
    const groups = section.querySelector('[data-product-groups]');
    const shopAll = section.querySelector('[data-shop-all]');
    tabs.addEventListener('click', e => {
      const b = e.target.closest('button[data-tab]'); if (!b) return;
      $$('button', tabs).forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      const idx = b.dataset.tab;
      if (groups) $$('.product-group', groups).forEach(g => g.classList.toggle('active', g.dataset.group === idx));
      // Point the "shop all" button at the active tab's collection
      if (shopAll) {
        if (b.dataset.tabUrl) shopAll.href = b.dataset.tabUrl;
        const base = shopAll.dataset.base || 'Shop all';
        shopAll.textContent = base + ' ' + (b.dataset.tabLabel || '');
      }
    });
  });

  /* ---------- FAQ ---------- */
  $$('.faq').forEach(faq => {
    faq.addEventListener('click', e => {
      const q = e.target.closest('.faq-q'); if (!q) return;
      const item = q.parentElement;
      const open = item.classList.contains('open');
      $$('.faq-item', faq).forEach(i => { i.classList.remove('open'); const a = $('.faq-a', i); if (a) a.style.maxHeight = null; });
      if (!open) { item.classList.add('open'); const a = $('.faq-a', item); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* ---------- Reveal on scroll ---------- */
  function reveal() {
    const els = $$('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver((ents) => { ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(e => { const r = e.getBoundingClientRect(); if (r.top < innerHeight * 0.92) e.classList.add('in'); else io.observe(e); });
  }
  reveal();
  addEventListener('load', () => setTimeout(() => $$('.reveal').forEach(e => e.classList.add('in')), 1400));
  document.addEventListener('shopify:section:load', () => { reveal(); refresh(); });
})();
